import { Component, ElementRef, EventEmitter, Injector, Input, OnInit, Output, ViewChild } from '@angular/core';
import { TermsMaintenanceService } from 'src/app/features/setting/service/terms-maintenance.service';
import { BaseComponent } from 'src/app/shared/components/base.component';



@Component({
  selector: 'laas-terms-selector',
  templateUrl: './terms-selector.component.html',
  styleUrls: ['./terms-selector.component.scss']
})
export class TermsSelectorComponent
  extends BaseComponent
  implements OnInit {
  @Input() uuid: string = '';
  @Input() browserLanguage: string = '';
  @Input() isView: boolean = false;
  @Input() isShow: boolean = true;
  @Input() contentView: string = '';
  @Output() closeDialog = new EventEmitter<any>();
  @Input() showTerms: boolean = false;
  confirm: string = '';
  disagree: string = '';
  AnnouncementDate: string = '';
  laasTermsContent: string = '';
  privateTermsContent: string = '';
  cookieTermsContent: string = '';
  customerNotificationContent: string = '';
  laasContent: string = '';
  updateDt: string = '';
  termsRead: boolean = false;
  selectedTabIndex: number = 0;
  isScrolledToBottom: boolean = false;
  agreeTerms: boolean = false;
  status: string = '';
  user: string = '';
  termsList: string = '';
  termsOfUse: string = '';
  cookiePolicy: string = '';
  privacyPolicy: string = '';
  customerNotification: string = '';
  checkTerms1: string = '';
  checkTerms2: string = '';

  constructor(

    injector: Injector,
    private termsMaintenanceService: TermsMaintenanceService
  ) {
    super(injector);
  }

  async ngOnInit(): Promise<void> {
    if (this.isView) {
      this.status = 'S';
      this.user = this.uuid
    } else {
      this.status = 'A';
      this.user = 'SYSTEM';
    }

    var Obj: any = {
      termsContent: "",
      termsTitle: 'laasTerms',
      uuid: this.uuid,
      createUser: this.user,
      language: this.browserLanguage,
      status: this.status
    };

    if (this.browserLanguage == 'zh-tw') {

      this.termsList = '條款聲明'
      this.termsOfUse = '平台服務條款'
      this.cookiePolicy = 'Cookie政策'
      this.privacyPolicy = '隱私權政策'
      this.customerNotification = '雲端服務客戶告知聲明'
      this.checkTerms1 = '我已閱讀並且同意所有條款聲明'

      this.confirm = '確認'
      if (this.isView) {
        this.disagree = '關閉'
      } else {
        this.disagree = '不同意'
      }
      this.AnnouncementDate = '發布日期'
    } else if (this.browserLanguage == 'zh-cn') {
      this.termsList = '条款声明'
      this.termsOfUse = '平台服务条款'
      this.cookiePolicy = 'Cookie政策'
      this.privacyPolicy = '隐私权政策'
      this.customerNotification = '云端服务客户告知声明'
      this.checkTerms1 = '我已阅读并且同意所有条款声明'

      this.confirm = '确认'
      if (this.isView) {
        this.disagree = '关闭'
      } else {
        this.disagree = '不同意'
      }
      this.AnnouncementDate = '发布日期'
    }
    else {
      this.termsList = 'Terms Policy'
      this.termsOfUse = 'LaaSTerms'
      this.cookiePolicy = 'CookiePolicy'
      this.privacyPolicy = 'PrivacyPolicy'
      this.customerNotification = 'CustomerNotification'
      this.checkTerms1 = 'I have read and agreed to all the above Terms Policy'

      this.confirm = 'Confirm'
      if (this.isView) {
        this.disagree = 'Close'
      } else {
        this.disagree = 'Disagree'
      }
      this.AnnouncementDate = 'AnnouncementDate'
    }


    this.termsMaintenanceService.getTerms(Obj).subscribe({
      next: result => {
        this.laasContent = result.laasTermsContent;
        this.privateTermsContent = result.privateTermsContent;
        this.cookieTermsContent = result.cookieTermsContent;
        this.customerNotificationContent = result.customerNotificationContent;
        this.updateDt = result.updateDt

        if (this.isView) {
          this.laasTermsContent = this.contentView
        } else {
          this.laasTermsContent = this.laasContent
        }
      }
    });

  }

  confirmBtnClick(event: any): void {
    if (this.agreeTerms) {
      if (!this.isView) {
        this.termsMaintenanceService.updateTermsFlag(this.user, this.uuid, this.browserLanguage).subscribe({
          next: result => {
            this.toastService.info("accept to terms")

          },
          error: err => {
            this.toastErrorMessage(err.error);
          }

        });
      }

      this.onCloseDialog(true);
    } else {
      this.toastErrorMessage('please agree to Terms')
    }

  }

  disagreeBtnClick(event: any): void {
    this.onCloseDialog(false);
  }

  onCloseDialog(event: any) {
    this.closeDialog.emit(event);
  }

  onTermsContentScroll(element: HTMLElement) {
    const scrollBottom = element.scrollHeight - element.clientHeight - element.scrollTop;
    if (scrollBottom < 1) {
      this.isScrolledToBottom = true;
    }
  }

  confirmBtnClickChanged(event: any) {
    this.agreeTerms = event.target.checked;

  }

onDialogHide() {
  // 發送事件給父層
  this.closeDialog.emit(true);  // 可以根據需要傳 true/false
}

}






